const stylesDesk = {
  menuPaper: {
    overflow: 'visible',
    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
    mt: 1.5,
    padding: '0px',
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: 'background.paper',
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: 0,
    },
  },
  menuContain: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    padding: '0px',
  },
  containContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    width: '450px',
    padding: '0px',
  },
  containList: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    maxHeight: '400px',
    width: '100%',
    padding: '0px',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#FF7043',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
    },
  },
  containLine: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: '0px',
    width: 'calc(100% - 20px)',
    borderBottom: '2px solid #d9d9d9',
  },
  containBtts: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    margin: '-9px 5px 3px 5px',
  },
  btnActive: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#ff7043',
    backgroundColor: '#d6d6d6',
    borderBottom: '2px solid #ff7043',
    borderRadius: '0px',
    padding: '10px 5px',
    '&:hover': {
      backgroundColor: '#d6d6d6',
    },
  },
  btnInactive: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: 'gray',
    backgroundColor: 'white',
    borderBottom: '2px solid gray',
    borderRadius: '0px',
    padding: '10px 5px',

    '&:hover': {
      backgroundColor: '#f2f2f2',
    },
  },

  menuList: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}

export default stylesDesk
